
import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Button,
    Box,
    Typography,
    Grid,
} from '@mui/material';
import { MdCancel } from "react-icons/md";
import { Formik, Form, FieldArray } from 'formik';
import * as Yup from 'yup';
import CustomInputLogin from '../../../../../Components/CustomInputLogin/CustomInputLogin';
import FileUploadComponent from '../../../../../Components/FileUploadComponent/FileUploadComponent';

import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../../../ReduxStore/actions';
// import PreviewComponent from '../../PreviewComponent/PreviewComponent';
// import LandingPage from '../../Home/Preview/LandingPage';
import { clearTableGetId } from '../../../../../ReduxStore/Slices/TableId/TableIdGetSlice';
import { clearCustomerId } from '../../../../../ReduxStore/Slices/Operator/customerSlice';
import { toast } from 'react-toastify';
import PreviewComponent from '../../../PreviewComponent/PreviewComponent';


const QuestionAndAnswersModal = ({ open, onClose, editData, section_name, ModalPreviewComponent }) => {
    const [uploadedFile, setUploadedFile] = useState(null);


    const role = sessionStorage.getItem('role')

    //   useEffect(() => {
    //     if (!open) return;
    //     const fetchData = async () => {
    //       const data1 = { data: {}, method: "get", apiName: `getAllRoles` };
    //       await dispatch(actions.GETALLROLES(data1));
    //     };
    //     fetchData();
    //   }, [dispatch, createRoleWithPermissions]);

    const dispatch = useDispatch()

    const { addStakeNowSectionPost } = useSelector(
        (state) => state?.addStakeNowSectionPost
    );


    const { addStakeNowSectionWithApproval } = useSelector(
        (state) => state?.addStakeNowSectionWithApproval
    );




    const { updateStakeNowSection } = useSelector(
        (state) => state?.updateStakeNowSection
    );

    const { updateStakeNowSectionForReApproval } = useSelector(
        (state) => state?.updateStakeNowSectionForReApproval
    );



    const [loading, setLoading] = useState(false);




    const [editResponseData, setEditResponseData] = useState()
    const TableId = useSelector((state) => state.Table.TableId);

    console.log(editResponseData, "editResponseDataeditResponseDataeditResponseData")
    console.log(TableId, "TebleIddddd")

    useEffect(() => {
        console.log(TableId, "TebleIddddd111")

        if (TableId) {
            console.log(TableId, "TebleIddddd222")

            const fetchData = async () => {
                const data1 = {
                    data: {},
                    method: "get",
                    apiName: `getStakeNowSectionById/${TableId}`,
                };
                const response = await dispatch(actions.GETSTAKENOWSECTIONBYID(data1));

                console.log(response, "responseresponse")

                if (response?.payload?.message === "Stake Now section retrieved successfully.") {
                    console.log("hiiii")

                    setEditResponseData(response?.payload?.data)
                    setUploadedFile({
                        fileUrl: response?.payload?.data.additional_data[0]?.banner,
                        type: "img",
                        progress: 100,
                    }
                    )
                    // console.log(response?.payload?.data.additional_data[0]?.banner,"yhfuwrfrkjrw")
                }
            };
            fetchData();
        }

    }, [open]);




    const handleSubmit = async (values, resetForm) => {
        setLoading(true)

        if (!TableId) {

            if (role === "superAdmin") {

                const data1 = {
                    data: {
                        section_name: section_name,//pass from parent component
                        heading: " ",
                        sub_heading: " ",
                        content: " ",
                        // heading: values?.heading_title,
                        // sub_heading: values?.heading_second_text,
                        // content: values?.heading_sub_text,
                        additional_data: {
                            card_design: values?.cards?.map((data) => ({

                                title: data?.card_title,
                                content: data?.card_content
                            }))
                        }
                    },
                    method: "Post",
                    apiName: `addStakeNowSectionWithApproval`
                };
                const responseData = await dispatch(actions.ADDSTAKENOWSECTIONWITHAPPROVAL(data1));

                if (responseData?.payload?.message === "Stake Now section added and approved successfully. Previous approved section deactivated.") {
                    // handlePreviewCloseModal()

                    // setTimeout(() => {
                    //     setLoading(false)
                    //     onClose()

                    //     handlePreviewCloseModal()

                    //     resetForm()

                    //     setUploadedFile(null)

                    // }, 2500)

                    setTimeout(() => {
                        setLoading(false)
                        onClose()

                        handlePreviewCloseModal()

                    }, 1500)

                    setTimeout(() => {
                        // setLoading(false)
                        toast.success(`Stake Now section added successfully!!`)

                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))

                        resetForm()

                        setUploadedFile(null)

                    }, 2000)
                } else {
                    setTimeout(() => {
                        setLoading(false)
                        onClose()

                        handlePreviewCloseModal()

                    }, 1500)

                    setTimeout(() => {
                        // setLoading(false)
                        // toast.success("Update successfully!!")
                        toast.error(responseData?.payload?.message)


                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))

                        resetForm()

                        setUploadedFile(null)

                    }, 2000)
                }
            } else {
                const data1 = {
                    data: {
                        section_name: section_name,
                        heading: " ",
                        sub_heading: " ",
                        content: " ",

                        // heading: values?.heading_title,
                        // sub_heading: values?.heading_second_text,
                        // content: values?.heading_sub_text,
                        additional_data: {
                            card_design: values?.cards?.map((data) => ({

                                title: data?.card_title,
                                content: data?.card_content
                            }))
                        }
                    },
                    method: "Post",
                    apiName: `addStakeNowSection`
                };
                const responseData = await dispatch(actions.ADDSTAKENOWSECTIONPOST(data1));
                if (responseData?.payload?.message === "Stake Now section added successfully.") {
                    // handlePreviewCloseModal()

                    // setTimeout(() => {
                    //     setLoading(false)
                    //     onClose()

                    //     handlePreviewCloseModal()

                    //     resetForm()

                    //     setUploadedFile(null)

                    // }, 2500)

                    setTimeout(() => {
                        setLoading(false)
                        onClose()

                        handlePreviewCloseModal()

                    }, 1500)

                    setTimeout(() => {
                        // setLoading(false)
                        toast.success("Stake Now section added successfully!!")

                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))

                        resetForm()

                        setUploadedFile(null)

                    }, 2000)
                } else {
                    setTimeout(() => {
                        setLoading(false)
                        onClose()

                        handlePreviewCloseModal()

                    }, 1500)

                    setTimeout(() => {
                        // setLoading(false)
                        // toast.success("Update successfully!!")
                        toast.error(responseData?.payload?.message)


                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))

                        resetForm()

                        setUploadedFile(null)

                    }, 2000)
                }
            }
        } else {

            if (role === "superAdmin") {

                const data1 = {
                    data: {
                        section_name: section_name,
                        heading: " ",
                        sub_heading: " ",
                        content: " ",

                        // heading: values?.heading_title,
                        // sub_heading: values?.heading_second_text,
                        // content: values?.heading_sub_text,
                        additional_data: {
                            card_design: values?.cards?.map((data) => ({

                                title: data?.card_title,
                                content: data?.card_content
                            }))
                        }
                    },
                    method: "put",
                    apiName: `updateStakeNowSection/${TableId}`
                };
                const responseData = await dispatch(actions.UPDATESTAKENOWSECTION(data1));

                if (responseData?.payload?.message === "Stake Now section updated successfully.") {
                    // handlePreviewCloseModal()

                    // setTimeout(() => {
                    //     setLoading(false)
                    //     onClose()

                    //     handlePreviewCloseModal()

                    //     resetForm()
                    //     dispatch(clearCustomerId(null))
                    //     dispatch(clearTableGetId(null))

                    //     setUploadedFile(null)

                    // }, 2500)
                    setTimeout(() => {
                        setLoading(false)
                        onClose()

                        handlePreviewCloseModal()

                    }, 1500)

                    setTimeout(() => {
                        // setLoading(false)
                        toast.success("Stake Now section update successfully!!")

                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))

                        resetForm()

                        setUploadedFile(null)

                    }, 2000)
                }
                else {
                    setTimeout(() => {
                        setLoading(false)
                        onClose()

                        handlePreviewCloseModal()

                    }, 1500)

                    setTimeout(() => {
                        // setLoading(false)
                        // toast.success("Update successfully!!")
                        toast.error(responseData?.payload?.message)


                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))

                        resetForm()

                        setUploadedFile(null)

                    }, 2000)
                }
            } else {
                const data1 = {
                    data: {
                        section_name: section_name,
                        heading: " ",
                        sub_heading: " ",
                        content: " ",

                        // content: values?.heading_sub_text,
                        additional_data: {
                            card_design: values?.cards?.map((data) => ({

                                title: data?.card_title,
                                content: data?.card_content
                            }))
                        }
                    },
                    method: "put",
                    apiName: `updateStakeNowSectionForReApproval/${TableId}`
                };
                const responseData = await dispatch(actions.UPDATESTAKENOWSECTIONFORREAPPROVAL(data1));
                if (responseData?.payload?.message === "Stake Now section updated and sent for re-approval.") {
                    // handlePreviewCloseModal()

                    // setTimeout(() => {
                    //     setLoading(false)
                    //     onClose()

                    //     handlePreviewCloseModal()
                    //     dispatch(clearCustomerId(null))
                    //     dispatch(clearTableGetId(null))

                    //     resetForm()

                    //     setUploadedFile(null)

                    // }, 2500)
                    setTimeout(() => {
                        setLoading(false)
                        onClose()

                        handlePreviewCloseModal()

                    }, 1500)

                    setTimeout(() => {
                        // setLoading(false)
                        toast.success("Stake Now section update successfully!!")

                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))

                        resetForm()

                        setUploadedFile(null)

                    }, 2000)
                } else {
                    setTimeout(() => {
                        setLoading(false)
                        onClose()

                        handlePreviewCloseModal()

                    }, 1500)

                    setTimeout(() => {
                        // setLoading(false)
                        // toast.success("Update successfully!!")
                        toast.error(responseData?.payload?.message)


                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))

                        resetForm()

                        setUploadedFile(null)

                    }, 2000)
                }
            }

        }
    }

    const [isPreviewModalOpen, setPreviewModalOpen] = useState(false)

    const handlePreviewOpenModal = () => {
        setPreviewModalOpen(true);
    };

    const handlePreviewCloseModal = () => {
        setPreviewModalOpen(false);
    };


    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            sx={{
                maxWidth: "600px",
                margin: "auto",
                "& .MuiPaper-root": { borderRadius: "14px" },
            }}
        >
            <Box sx={{ position: 'relative' }}>
                {/* Dialog Header */}
                <Box className="dialog-heading">
                    <IconButton
                        aria-label="Close"
                        onClick={() => {
                            onClose()
                            dispatch(clearCustomerId(null))
                            dispatch(clearTableGetId(null))
                        }}
                        sx={{ position: 'absolute', top: 8, right: 8, color: 'text.secondary' }}
                    >
                        <MdCancel />
                    </IconButton>
                    <DialogTitle className="custom-dialog-title">
                        <Typography fontSize="16px" color="white">
                            Stake Now Modal
                        </Typography>
                    </DialogTitle>
                </Box>

                {/* Formik Form */}
                <Formik
                    enableReinitialize
                    initialValues={{

                        cards: editResponseData?.additional_data?.card_design?.map((data) => ({

                        }))
                            || [{ card_title: '', card_content: '' }]
                    }}



                    validationSchema={Yup.object({

                        cards: Yup.array().of(
                            Yup.object({
                                card_title: Yup.string().required('Card Title is required'),
                                card_content: Yup.string().required('Card Content is required'),
                            })
                        )
                    })}
                    onSubmit={(values, { resetForm }) => {
                        console.log("Form values:", values);
                        // handleSubmit(values, resetForm)
                        isPreviewModalOpen ? handleSubmit(values, resetForm) : handlePreviewOpenModal()

                        // resetForm();
                    }}
                >
                    {({ values, setFieldValue, handleSubmit, resetForm }) => (
                        <Form onSubmit={handleSubmit}>
                            <DialogContent dividers>
                                <Grid container spacing={2}>
                                    {/* Heading Section */}


                                    {/* Card Section */}
                                    <Grid item xs={12}>

                                        <FieldArray name="cards">
                                            {({ push, remove }) => (
                                                <>
                                                    {/* <Grid item xs={12}>
                                                        <Typography variant='body2' sx={{ color: "#C38F51" }}>Card Design</Typography>
                                                    </Grid> */}

                                                    {values.cards.map((card, index) => (
                                                        <Grid container spacing={2} key={index} sx={{ mt: index > 0 ? 1 : 0 }}>
                                                            <Grid item xs={12}>
                                                                <Typography variant='body2' sx={{ color: "#C38F51" }}>Card Design {index + 1}</Typography>
                                                            </Grid>
                                                            <Grid item xs={12} md={12}>
                                                                <CustomInputLogin
                                                                    label="Card Title"
                                                                    name={`cards.${index}.card_title`}
                                                                    inputType="text"
                                                                    custPlaceholder="Enter Card Title"
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                <CustomInputLogin
                                                                    label="Content"
                                                                    name={`cards.${index}.card_content`}
                                                                    inputType="textarea"
                                                                    custPlaceholder="Enter Content"
                                                                />
                                                            </Grid>
                                                            {index > 0 && (
                                                                <Grid item xs={12}>
                                                                    <Button
                                                                        variant="outlined"
                                                                        color="error"
                                                                        onClick={() => remove(index)}
                                                                        sx={{
                                                                            textTransform: "none",
                                                                            color: "white",
                                                                            fontSize: "16px",
                                                                            boxShadow: "none",
                                                                            padding: { xs: "0px 20px", md: "0px 40px" },
                                                                            minHeight: "40px",
                                                                            borderRadius: "23px",
                                                                            background: "#3B4056",
                                                                            "&:hover": { backgroundColor: "#3B4056" },
                                                                        }}
                                                                    // sx={{ textTransform: "none" }}
                                                                    >
                                                                        Remove Card
                                                                    </Button>

                                                                </Grid>)}
                                                        </Grid>
                                                    ))}

                                                    {/* Add Card Button */}
                                                    {/* {values.cards.length < 3 && ( */}
                                                    <Grid item xs={12} sx={{ display: "flex", justifyContent: "end" }}>
                                                        <Button
                                                            variant="outlined"
                                                            onClick={() => push({ card_title: '', card_content: '', image: null })}
                                                            sx={{
                                                                textTransform: "none",
                                                                color: "#C38F51",
                                                                borderColor: "#C38F51",
                                                                "&:hover": { backgroundColor: "#C38F51", color: "white" },
                                                            }}
                                                        >
                                                            Add Card
                                                        </Button>
                                                    </Grid>
                                                    {/* )} */}
                                                </>
                                            )}
                                        </FieldArray>
                                    </Grid>

                                </Grid>

                                {/* Action Buttons */}
                                <Grid sx={{ display: "flex", justifyContent: 'end', mt: 4 }}>
                                    <Button
                                        onClick={() => {
                                            onClose()
                                            dispatch(clearCustomerId(null))
                                            dispatch(clearTableGetId(null))
                                        }}
                                        variant="text"
                                        sx={{
                                            textTransform: "none",
                                            color: "black",
                                            fontSize: "16px",
                                            mr: "10px",
                                            padding: { xs: "0px 20px", md: "0px 40px" },
                                            minHeight: "40px",
                                            borderRadius: "23px",
                                            background: "white",
                                            border: "1px solid black",
                                            "&:hover": { backgroundColor: "#3B4056", color: "white" },
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        type="submit"
                                        // onClick={handlePreviewOpenModal}

                                        variant="contained"
                                        sx={{
                                            textTransform: "none",
                                            color: "white",
                                            fontSize: "16px",
                                            boxShadow: "none",
                                            padding: { xs: "0px 20px", md: "0px 40px" },
                                            minHeight: "40px",
                                            borderRadius: "23px",
                                            background: "#C38F51",
                                            "&:hover": { backgroundColor: "#3B4056" },
                                        }}
                                    >
                                        Preview
                                    </Button>
                                </Grid>

                            </DialogContent>

                            <PreviewComponent
                                showSubmitButton={true}
                                open={isPreviewModalOpen}
                                // ModalPreviewComponent={OfferSection}
                                ModalPreviewComponent={ModalPreviewComponent}

                                onClose={handlePreviewCloseModal}
                                values={values}
                                resetForm={resetForm}
                                ParentModalClose={onClose}
                                handleSubmit={handleSubmit}
                                loading={loading}
                                setLoading={setLoading}
                            />
                        </Form>
                    )}
                </Formik>
            </Box>
        </Dialog >
    );
};

export default QuestionAndAnswersModal;
